import React, { Component } from 'react';
import Button from 'components/Button';
import Input from 'components/Input';
import PlaceHolder from 'components/PlaceHolder';

export default class  SendProposalPlaceholder extends Component {
	
	render() {
		return (
			<div className='Forms__vehicleSendProposal' >
				<div className="Forms__vehicleSendProposal__container-scroll">
					<div className="Forms__vehicleSendProposal__container">
						<strong className='Forms__vehicleSendProposal__container__price'>
                            <PlaceHolder width="px" px="200" />
						</strong>
						<strong className="Forms__vehicleSendProposal__container__send-message-seller"><PlaceHolder width="px" px="316" /></strong>
						<form autoComplete='off' className="Forms__cookie Forms__cookie--send-proposal">
							<div className={'Forms__cookie__stage'}>
                                <div className={'Form__field'}><PlaceHolder /></div>
                                <div className={'Form__field'}><PlaceHolder /></div>
                                <div className={'Form__field'}><PlaceHolder /></div>
                                <div className={'Form__field Form__field--message'}><PlaceHolder /></div>
								<div className={'Forms__cookie__edit-information'}><PlaceHolder /></div>
							</div>
						</form>
                            <PlaceHolder className=' Button Button--green Button--send-message Button--send-proposal Button--disabled' />
					</div>
				</div>
			</div>
		)
	}
}